import { Button, Icon } from '@components/index';

interface CreateGroupHeaderProps {
  step: 'basic' | 'member';
  onSave: () => void;
  isSaveDisabled: boolean;
  isLoading: boolean;
  onBack: () => void;
}

const CreateGroupHeader = ({
  step,
  onSave,
  isSaveDisabled,
  isLoading,
  onBack
}: CreateGroupHeaderProps) => (
  <div className="flex h-22 w-full shrink-0 items-center justify-between bg-white p-6">
    <div className="flex items-center gap-2">
      <Icon className="cursor-pointer" name="arrow-left" onClick={onBack} />
      <div className="text-2xl font-bold text-cofeeNeutral11">New group</div>
    </div>
    <div className="flex items-center gap-4">
      <Button
        label="Cancel"
        handleClick={onBack}
        variant="tertiary"
        className="min-w-30"
      />
      <Button
        label={step === 'basic' ? 'Save and next' : 'Save'}
        handleClick={onSave}
        variant="primary"
        className="min-w-30"
        disabled={isSaveDisabled}
        loading={isLoading}
      />
    </div>
  </div>
);

export default CreateGroupHeader;
